import React from 'react';
import { CheckboxField } from '@zola/zola-ui/src/components/Form/CheckboxField';

import { FilterOption } from './Menu.style';
import { ActiveFilters, IndividualVisibilityCheck } from '../FilterTypes';

interface CustomPhotoMenuProps {
  activeFilters: Pick<ActiveFilters, 'has_custom_photo' | 'has_no_custom_photo'>;
  updateFilter: (filter: 'has_custom_photo' | 'has_no_custom_photo', value: boolean) => void;
  individualVisibilityCheck: IndividualVisibilityCheck;
}

export const CustomPhotoMenu: React.FC<CustomPhotoMenuProps> = ({
  activeFilters,
  updateFilter,
  individualVisibilityCheck,
}) => {
  const {
    has_custom_photo: hasCustomPhotoOptionVisible,
    has_no_custom_photo: hasNoCustomPhotoOptionVisible,
  } = individualVisibilityCheck;

  const { has_custom_photo, has_no_custom_photo } = activeFilters;

  return (
    <>
      {hasCustomPhotoOptionVisible && (
        <FilterOption>
          <CheckboxField
            label={
              <span>
                Only show designs <b>with photos</b>
              </span>
            }
            id="custom_photo"
            key="custom_photo"
            checked={has_custom_photo}
            onChange={() => {
              updateFilter('has_custom_photo', !has_custom_photo);
            }}
            meta={{ touched: true }}
          />
        </FilterOption>
      )}
      {hasNoCustomPhotoOptionVisible && (
        <FilterOption>
          <CheckboxField
            label={
              <span>
                Only show designs <b>without photos</b>
              </span>
            }
            id="no_custom_photo"
            key="no_custom_photo"
            type="checkbox"
            checked={has_no_custom_photo}
            onChange={() => {
              updateFilter('has_no_custom_photo', !has_no_custom_photo);
            }}
            meta={{ touched: true }}
          />
        </FilterOption>
      )}
    </>
  );
};
